import Sidebar from './Sidebar';
import SidebarContainer from './SidebarContainer';

export { SidebarContainer };
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js